import React from 'react';
import { FadeIn } from './FadeIn';
import { DumbbellIcon, UtensilsIcon, MoonIcon } from 'lucide-react';
export function Triada() {
  const pilares = [{
    icon: <DumbbellIcon className="w-8 h-8 text-running-blue" data-id="element-231" />,
    num: 'U7',
    title: 'Fuerza Específica para Corredores',
    desc: 'El programa de 24 semanas que convierte al corredor en un atleta completo. Los 4 tipos de fuerza, la evaluación funcional y las 3 fases de desarrollo construidas desde la biomecánica del running. Mejora la economía de carrera hasta un 8% y reduce las lesiones hasta un 50%.',
    badge: 'Pilar 1 del Cuerpo Completo'
  }, {
    icon: <UtensilsIcon className="w-8 h-8 text-running-blue" data-id="element-232" />,
    num: 'U8',
    title: 'Nutrición del Corredor de Alto Rendimiento',
    desc: 'El sistema completo de alimentación aplicada sin mitos ni modas. El timing de macronutrientes, los protocolos de carga de carbohidratos, la estrategia de geles en carrera y la suplementación con evidencia real. El combustible que convierte el entrenamiento en adaptación.',
    badge: 'Pilar 2 del Cuerpo Completo'
  }, {
    icon: <MoonIcon className="w-8 h-8 text-running-blue" data-id="element-233" />,
    num: 'U9',
    title: 'Recuperación Activa y Regeneración',
    desc: 'El entrenamiento invisible. Protocolos de sueño para maximizar la hormona de crecimiento, rutinas de movilidad diaria, monitoreo de FCR y HRV, y el plan de recuperación semanal integrado. Donde ocurre la supercompensación real.',
    badge: 'Pilar 3 del Cuerpo Completo'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-running-surface relative overflow-hidden" data-id="element-234">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-running-blue/3 rounded-full blur-[120px] pointer-events-none" data-id="element-235" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-236">
        <FadeIn data-id="element-237">
          <div className="text-center mb-16" data-id="element-238">
            <span className="inline-block bg-running-blue/10 border border-running-blue/30 text-running-blue text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-6" data-id="element-239">
              La Tríada del Cuerpo Completo
            </span>
            <h2 className="text-3xl sm:text-5xl font-display font-bold text-white mb-6" data-id="element-240">
              El running no es solo kilómetros.{' '}
              <span className="text-running-blue" data-id="element-241">
                Son tres sistemas que trabajan juntos.
              </span>
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-242">
              El corredor que solo corre tiene un techo. El corredor que
              entrena, se alimenta y se recupera correctamente no tiene techo
              visible.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-243">
          {pilares.map((pilar, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-244">
              <div className="bg-running-dark border border-running-muted rounded-2xl p-6 sm:p-8 h-full flex flex-col relative overflow-hidden group hover:border-running-blue/50 transition-all" data-id="element-245">
                {/* Glow effect on hover */}
                <div className="absolute inset-0 bg-running-blue/0 group-hover:bg-running-blue/3 transition-all rounded-2xl" data-id="element-246" />

                <div className="relative z-10 flex flex-col h-full" data-id="element-247">
                  <div className="flex items-center justify-between mb-6" data-id="element-248">
                    <div className="bg-running-surface w-14 h-14 rounded-xl flex items-center justify-center border border-running-muted group-hover:border-running-blue/30 transition-colors" data-id="element-249">
                      {pilar.icon}
                    </div>
                    <span className="text-running-blue/50 font-black text-4xl font-display" data-id="element-250">
                      {pilar.num}
                    </span>
                  </div>

                  <span className="inline-block text-[10px] font-bold tracking-widest uppercase text-running-blue/70 mb-3" data-id="element-251">
                    {pilar.badge}
                  </span>

                  <h3 className="text-xl font-display font-bold text-white mb-4" data-id="element-252">
                    {pilar.title}
                  </h3>

                  <p className="text-gray-400 leading-relaxed flex-grow" data-id="element-253">
                    {pilar.desc}
                  </p>

                  <div className="mt-6 pt-4 border-t border-running-muted" data-id="element-254">
                    <p className="text-running-blue text-sm font-bold" data-id="element-255">
                      Incluido en el Bundle Completo →
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-256">
          <div className="mt-12 bg-running-dark border border-running-blue/20 rounded-2xl p-6 sm:p-8 text-center shadow-[0_0_30px_rgba(61,232,255,0.05)]" data-id="element-257">
            <p className="text-white font-bold text-xl sm:text-2xl mb-2" data-id="element-258">
              "El entrenamiento sin fuerza tiene un techo.
            </p>
            <p className="text-white font-bold text-xl sm:text-2xl mb-2" data-id="element-259">
              El entrenamiento sin nutrición no produce las adaptaciones que
              podría.
            </p>
            <p className="text-running-blue font-black text-xl sm:text-2xl" data-id="element-260">
              El entrenamiento sin recuperación produce lesiones en lugar de
              rendimiento."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}